import { useEffect, useState } from 'react';
import api from '../services/api';

export default function useFetch(endpoint = '') {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchApi = async () => {
      try {
        setLoading(true);
        setError(false);
        const res = await api.get(endpoint);
        setResponse(res);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchApi();
  }, [endpoint]);

  return { response, error, loading };
}
